import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button, Accordion, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { isBrowser } from "react-device-detect";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement } from "@stripe/react-stripe-js";

//STYLES
import * as CheckoutStyles from "../../styles/checkout/checkout";

//ACTIONS
import * as PrintingShopActions from "../../../../../../../envStore/actions/3dPrintingShop";

//COMPONENTS
import PaymentIntent from "./paymentIntent";

function Checkout() {
    const user = useSelector((state) => state.user);
    const printingShop = useSelector((state) => state.printingShop);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState("");
    const [paymentIntentID, setPaymentIntentID] = useState(null);

    const [coupon, setCoupon] = useState({
        success: false,
        code: "",
        description: "",
        takenOffAmount: 0
    });

    const couponModalDefaults = {
        errorType: "",
        message: "",
        open: false,
        dates: {},
        amount: 0
    };
    const [couponModal, setCouponModal] = useState(couponModalDefaults);

    function handleCloseCouponModal() {
        setCouponModal(couponModalDefaults);
    }

    useEffect(() => {
        if (printingShop.items.length == 0) {
            navigate("../basket");
        } else {
            loadData();
        }
    }, []);

    function loadData() {
        const data = { userID: user.id };
        Axios.post("/pods/3dPrintingShop/checkout/getUserAddressAndPostageData", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    const values = { ...data.userDetails[0] };
                    const valids = {};
                    for (const [key, value] of Object.entries(values)) {
                        if (value != "") {
                            valids[key] = true;
                        } else {
                            valids[key] = false;
                        }
                    }

                    const allTrue = Object.keys(valids).every(function (k) {
                        return valids[k] === true;
                    });

                    dispatch(PrintingShopActions.UpdateCheckoutFormData({ ...printingShop.checkoutFormData, values, valids, wholeForm: allTrue }));

                    const checkoutSubTotal = printingShop.basketTotal;

                    let postage = 0;
                    if (data.postageActive) {
                        postage = parseInt(data.postageOptions.find((post) => post.uuid == data.postageOptions[0].uuid).price);
                    }

                    const checkoutTotal = checkoutSubTotal + postage;

                    dispatch(
                        PrintingShopActions.LoadPostageOptionsAndTotals(
                            data.postageOptions,
                            data.postageOptions[0].uuid,
                            data.postageActive,
                            checkoutSubTotal,
                            checkoutTotal
                        )
                    );
                    setStripePromise(loadStripe(data.stripePublishableKey));
                    handleCreatePaymentIntent(checkoutTotal);
                    // setTimeout(() => {
                    //     // console.log(printingShop.checkoutTotal);
                    // }, 5000);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleCreatePaymentIntent(paymentAmount) {
        const data = { totalPaymentAmount: paymentAmount };
        Axios.post("/pods/3dPrintingShop/checkout/create-payment-intent", data)
            .then((res) => {
                const data = res.data;
                setPaymentIntentID(data.paymentIntentID);
                setClientSecret(data.clientSecret);
            })
            .catch((err) => console.log(err));
    }

    function handleOnTouched(event) {
        const { name } = event.target;

        const touched = { ...printingShop.checkoutFormData.touched };

        touched[name] = true;

        dispatch(PrintingShopActions.UpdateCheckoutFormData({ ...printingShop.checkoutFormData, touched }));
    }

    function handleOnChange(event) {
        const { name, value } = event.target;

        const values = { ...printingShop.checkoutFormData.values };
        const valids = { ...printingShop.checkoutFormData.valids };

        values[name] = value;

        let isValid = false;
        if (value != "") {
            isValid = true;
        }

        valids[name] = isValid;

        const allTrue = Object.keys(valids).every(function (k) {
            return valids[k] === true;
        });

        dispatch(PrintingShopActions.UpdateCheckoutFormData({ ...printingShop.checkoutFormData, values, valids, wholeForm: allTrue }));
    }

    function numbersDecKeyPress(event) {
        if (!/[0-9+]/.test(event.key)) {
            event.preventDefault();
        }
    }

    function handleCheckOnChange(uuid) {
        const postage = parseInt(printingShop.postageOptions.find((post) => post.uuid == uuid).price);
        const checkoutTotal = printingShop.checkoutSubTotal + postage;
        dispatch(PrintingShopActions.UpdatePostageSelectedAndTotals(uuid, checkoutTotal));
        handleCreatePaymentIntent(checkoutTotal);
    }

    async function handleBuyNow() {}

    //COUPON FUNCTIONS
    function handleCouponTextChange(event) {
        const { value } = event.target;

        setCoupon((prevState) => {
            return { code: value };
        });
    }

    function handleRedeemButton() {
        const data = { code: coupon.code, totalOrder: printingShop.basketTotal };
        Axios.post("/pods/3dPrintingShop/checkout/checkCouponCode", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "Yes") {
                    let dates = {};
                    let amount = 0;
                    if (data.errorType == "date") {
                        dates = {
                            startDate: data.startDate,
                            endDate: data.endDate
                        };
                    }
                    if (data.errorType == "overAmount") {
                        amount = parseFloat(data.overAmount);
                    }
                    setCouponModal({ errorType: data.errorType, message: data.message, dates, amount, open: true });
                } else {
                    setCoupon((prevState) => {
                        return { ...prevState, description: data.description, takenOffAmount: data.takenOffAmount, success: true };
                    });
                    const postageUUID = printingShop.selectedPostage;
                    const postage = parseInt(printingShop.postageOptions.find((post) => post.uuid == postageUUID).price);

                    let checkoutTotal = data.subTotal + postage;

                    dispatch(PrintingShopActions.UpdateTotalsFromCoupon(data.subTotal, checkoutTotal, data.couponUUID));
                    handleCreatePaymentIntent(checkoutTotal);
                }
            })
            .catch((err) => console.log(err));
    }

    const browserDisplay = (
        <div>
            <h1 style={CheckoutStyles.title}>Checkout</h1>
            <Row>
                <Col sm={2}></Col>
                <Col sm={8}>
                    <Accordion style={CheckoutStyles.itemsAccordion}>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <Row style={CheckoutStyles.itemsRow}>
                                    <Col>
                                        {printingShop.basketItemTotal > 1
                                            ? `${printingShop.basketItemTotal} Items`
                                            : `${printingShop.basketItemTotal} Item`}{" "}
                                    </Col>
                                    <Col style={CheckoutStyles.columnRight}>
                                        {coupon.success ? (
                                            <strong> Basket Total: £{(parseInt(printingShop.basketTotal) / 100).toFixed(2)}</strong>
                                        ) : (
                                            <strong> Sub Total: £{(parseInt(printingShop.checkoutSubTotal) / 100).toFixed(2)}</strong>
                                        )}
                                    </Col>
                                </Row>
                            </Accordion.Header>
                            <Accordion.Body>
                                {printingShop.items.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <Row key={index}>
                                                <Col>{item.productDetails.title}</Col>
                                                <Col style={CheckoutStyles.itemsAccordion_SecondColumn}>Qty: {item.quantity}</Col>
                                                <Col style={CheckoutStyles.itemsAccordion_ThirdColumn}>
                                                    <strong>
                                                        £{((parseInt(item.productDetails.price) * parseInt(item.quantity)) / 100).toFixed(2)}
                                                    </strong>
                                                    {parseInt(item.quantity) > 1 && (
                                                        <>
                                                            <br />£{(parseInt(item.productDetails.price) / 100).toFixed(2)} each
                                                        </>
                                                    )}
                                                </Col>
                                            </Row>
                                            {index < printingShop.items.length - 1 && <br />}
                                        </div>
                                    );
                                })}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                    <br />
                    <Row>
                        <Col>
                            <div style={coupon.success ? CheckoutStyles.hidden : CheckoutStyles.show}>
                                <strong>Have you got a coupon code?</strong> <br />
                                Enter below:
                                <Form.Control
                                    type="text"
                                    style={CheckoutStyles.coupon_TextBox}
                                    value={coupon.code}
                                    onChange={handleCouponTextChange}
                                    maxLength={20}
                                />
                                <Button onClick={handleRedeemButton}>Redeem</Button>
                            </div>
                        </Col>
                        <Col style={CheckoutStyles.rightPadding}>
                            <div style={coupon.success ? CheckoutStyles.show : CheckoutStyles.hidden}>
                                <Row>
                                    <Col>
                                        <strong>Coupon Accepted</strong> <br />
                                        {coupon.code} - {coupon.description}
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col style={{ ...CheckoutStyles.columnRight }}>
                                        <strong>Discount: </strong>
                                    </Col>
                                    <Col sm={2}>-£{(parseInt(coupon.takenOffAmount) / 100).toFixed(2)}</Col>
                                </Row>
                                <br />
                                <Row style={{ ...CheckoutStyles.columnRight }}>
                                    <Col>
                                        <strong>Sub Total: </strong>
                                    </Col>
                                    <Col sm={2}>£{(parseInt(printingShop.checkoutSubTotal) / 100).toFixed(2)}</Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <strong>Postage:</strong>
                    {printingShop.postageOptions.length > 0 && (
                        <div>
                            {printingShop.postageOptions.map((postage, index) => {
                                return (
                                    <Form.Check
                                        key={index}
                                        type="radio"
                                        checked={postage.uuid == printingShop.selectedPostage && true}
                                        label={`${postage.name} (£${(postage.price / 100).toFixed(2)})`}
                                        onChange={handleCheckOnChange.bind(this, postage.uuid)}
                                    />
                                );
                            })}
                            {printingShop.postageOptions.length > 0 &&
                                printingShop.postageOptions.find((post) => post.uuid == printingShop.selectedPostage).emailType == "byPost" && (
                                    <div>
                                        <br />
                                        <strong>Address:</strong> <br /> <br />
                                        <Row>
                                            <Col>
                                                Address Line 1:
                                                <br />
                                                <Form.Group>
                                                    <Form.Control
                                                        isInvalid={
                                                            printingShop.checkoutFormData.touched.addressLine1 &&
                                                            !printingShop.checkoutFormData.valids.addressLine1
                                                                ? true
                                                                : false
                                                        }
                                                        type="text"
                                                        name="addressLine1"
                                                        value={printingShop.checkoutFormData.values.addressLine1}
                                                        onChange={handleOnChange}
                                                        onBlur={handleOnTouched}
                                                    />
                                                    <Form.Control.Feedback type="invalid">Please complete Address Line 1</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                Address Line 2:
                                                <br />
                                                <Form.Group>
                                                    <Form.Control
                                                        isInvalid={
                                                            printingShop.checkoutFormData.touched.addressLine2 &&
                                                            !printingShop.checkoutFormData.valids.addressLine2
                                                                ? true
                                                                : false
                                                        }
                                                        type="text"
                                                        name="addressLine2"
                                                        value={printingShop.checkoutFormData.values.addressLine2}
                                                        onChange={handleOnChange}
                                                        onBlur={handleOnTouched}
                                                    />
                                                    <Form.Control.Feedback type="invalid">Please complete Address Line 2</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col>
                                                Town:
                                                <br />
                                                <Form.Group>
                                                    <Form.Control
                                                        isInvalid={
                                                            printingShop.checkoutFormData.touched.town && !printingShop.checkoutFormData.valids.town
                                                                ? true
                                                                : false
                                                        }
                                                        type="text"
                                                        name="town"
                                                        value={printingShop.checkoutFormData.values.town}
                                                        onChange={handleOnChange}
                                                        onBlur={handleOnTouched}
                                                    />
                                                    <Form.Control.Feedback type="invalid">Please enter a town</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                Postcode:
                                                <br />
                                                <Form.Group>
                                                    <Form.Control
                                                        isInvalid={
                                                            printingShop.checkoutFormData.touched.postcode &&
                                                            !printingShop.checkoutFormData.valids.postcode
                                                                ? true
                                                                : false
                                                        }
                                                        type="text"
                                                        name="postcode"
                                                        value={printingShop.checkoutFormData.values.postcode}
                                                        onChange={handleOnChange}
                                                        onBlur={handleOnTouched}
                                                    />
                                                    <Form.Control.Feedback type="invalid">Please enter a post code</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col>
                                                Telephone Number:
                                                <br />
                                                <Form.Group>
                                                    <Form.Control
                                                        isInvalid={
                                                            printingShop.checkoutFormData.touched.tel && !printingShop.checkoutFormData.valids.tel
                                                                ? true
                                                                : false
                                                        }
                                                        type="text"
                                                        name="tel"
                                                        value={printingShop.checkoutFormData.values.tel}
                                                        onKeyPress={numbersDecKeyPress}
                                                        onChange={handleOnChange}
                                                        onBlur={handleOnTouched}
                                                    />
                                                    <Form.Control.Feedback type="invalid">Please enter a telephone number</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                    </div>
                                )}
                            <Row>
                                <Col></Col>
                                <Col style={{ ...CheckoutStyles.columnRight, ...CheckoutStyles.rightPadding }}>
                                    {printingShop.postageOptions.length > 0 && (
                                        <>
                                            <Row>
                                                <Col>
                                                    <strong>Postage Total:</strong>
                                                </Col>
                                                <Col sm={2}>
                                                    £
                                                    {(
                                                        printingShop.postageOptions.find((post) => post.uuid == printingShop.selectedPostage).price /
                                                        100
                                                    ).toFixed(2)}
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    )}
                    <Row>
                        <Col></Col>
                        <Col style={{ ...CheckoutStyles.columnRight, ...CheckoutStyles.rightPadding }}>
                            <Row>
                                <Col>
                                    <strong> Total:</strong>
                                </Col>
                                <Col sm={2}>£{(printingShop.checkoutTotal / 100).toFixed(2)}</Col>
                            </Row>
                        </Col>
                    </Row>
                    <br />
                    {stripePromise && clientSecret && (
                        <Elements stripe={stripePromise} options={{ clientSecret }}>
                            <PaymentIntent couponDetails={coupon} paymentIntentID={paymentIntentID} />
                        </Elements>
                    )}
                </Col>
                <Col sm={2}></Col>
            </Row>
            <Modal show={couponModal.open} onHide={handleCloseCouponModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Coupon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {couponModal.errorType == "normal" && <div>{couponModal.message}</div>}
                    {couponModal.errorType == "date" && (
                        <div>
                            This coupon is only valid between: <br />
                            <br />
                            {console.log(couponModal.dates)}
                            <strong>{couponModal.dates.startDate} 00:00</strong> - <strong>{couponModal.dates.endDate} 23:59</strong>
                        </div>
                    )}
                    {couponModal.errorType == "overAmount" && (
                        <div>
                            This coupon is only valid on orders over <strong>£{couponModal.amount.toFixed(2)}</strong>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseCouponModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );

    // const browserDisplay2 = (
    //     <div>
    //         <h1 style={CheckoutStyles.title}>Checkout</h1>
    //         <Row>
    //             <Col sm={2}></Col>
    //             <Col sm={8}>
    //                 {printingShop.postageActive && (
    //                     <div>
    //                         <Row>
    //                             <Col md="auto">
    //                                 <strong>Postage:</strong> <br /> <br />
    //                             </Col>
    //                             <Col>
    //                                 <br />
    //                                 {printingShop.postageOptions.map((postage, index) => {
    //                                     return (
    //                                         <Form.Check
    //                                             key={index}
    //                                             type="radio"
    //                                             checked={postage.uuid == printingShop.selectedPostage && true}
    //                                             label={`${postage.name} (£${(postage.price / 100).toFixed(2)})`}
    //                                             onChange={handleCheckOnChange.bind(this, postage.uuid)}
    //                                         />
    //                                     );
    //                                 })}
    //                             </Col>
    //                         </Row>
    //                     </div>
    //                 )}
    //                 <br />

    //                 <br />
    //             </Col>
    //             <Col sm={2} style={{ padding: 0 }}>
    //                 <CheckoutSideBar buyNowFunction={handleBuyNow} />
    //             </Col>
    //         </Row>
    //         {stripePromise && clientSecret && (
    //             <Elements stripe={stripePromise} options={{ clientSecret }}>
    //                 <PaymentIntent />
    //             </Elements>
    //         )}
    //     </div>
    // );

    const mobileDisplay = (
        <div style={CheckoutStyles.mobile_body}>
            <Accordion style={CheckoutStyles.itemsAccordion}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <Row style={CheckoutStyles.itemsRow}>
                            <Col>
                                {printingShop.basketItemTotal > 1
                                    ? `${printingShop.basketItemTotal} Items`
                                    : `${printingShop.basketItemTotal} Item`}{" "}
                            </Col>
                            <Col style={CheckoutStyles.columnRight}>
                                {coupon.success ? (
                                    <strong> Basket Total: £{(parseInt(printingShop.basketTotal) / 100).toFixed(2)}</strong>
                                ) : (
                                    <strong> Sub Total: £{(parseInt(printingShop.checkoutSubTotal) / 100).toFixed(2)}</strong>
                                )}
                            </Col>
                        </Row>
                    </Accordion.Header>
                    <Accordion.Body>
                        {printingShop.items.map((item, index) => {
                            return (
                                <div key={index}>
                                    <Row key={index}>
                                        <Col>{item.productDetails.title}</Col>
                                        <Col style={CheckoutStyles.itemsAccordion_SecondColumn}>Qty: {item.quantity}</Col>
                                        <Col style={CheckoutStyles.itemsAccordion_ThirdColumn}>
                                            <strong>£{((parseInt(item.productDetails.price) * parseInt(item.quantity)) / 100).toFixed(2)}</strong>
                                            {parseInt(item.quantity) > 1 && (
                                                <>
                                                    <br />£{(parseInt(item.productDetails.price) / 100).toFixed(2)} each
                                                </>
                                            )}
                                        </Col>
                                    </Row>
                                    {index < printingShop.items.length - 1 && <br />}
                                </div>
                            );
                        })}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <br />
            {coupon.success ? (
                <div>
                    <strong>Coupon Accepted</strong> <br />
                    {coupon.code} - {coupon.description}
                    <br />
                    <strong>Discount: </strong> <br />
                    -£{(parseInt(coupon.takenOffAmount) / 100).toFixed(2)} <br />
                    <strong>Sub Total: </strong> <br />£{(parseInt(printingShop.checkoutSubTotal) / 100).toFixed(2)}
                </div>
            ) : (
                <div>
                    <strong>Have you got a coupon code?</strong> <br />
                    Enter below:
                    <Form.Control
                        type="text"
                        style={CheckoutStyles.coupon_TextBox}
                        value={coupon.code}
                        onChange={handleCouponTextChange}
                        maxLength={20}
                    />
                    <Button onClick={handleRedeemButton}>Redeem</Button>
                </div>
            )}
            <br />
            {printingShop.postageActive && (
                <div>
                    <strong>Postage:</strong> <br /> <br />
                    {printingShop.postageOptions.map((postage, index) => {
                        return (
                            <Form.Check
                                key={index}
                                type="radio"
                                checked={postage.uuid == printingShop.selectedPostage && true}
                                label={`${postage.name} (£${(postage.price / 100).toFixed(2)})`}
                                onChange={handleCheckOnChange.bind(this, postage.uuid)}
                            />
                        );
                    })}
                </div>
            )}
            {printingShop.postageOptions.length > 0 &&
                printingShop.postageOptions.find((post) => post.uuid == printingShop.selectedPostage).emailType == "byPost" && (
                    <div>
                        <strong>Address:</strong> <br /> <br />
                        Address Line 1:
                        <br />
                        <Form.Group>
                            <Form.Control
                                isInvalid={
                                    printingShop.checkoutFormData.touched.addressLine1 && !printingShop.checkoutFormData.valids.addressLine1
                                        ? true
                                        : false
                                }
                                type="text"
                                name="addressLine1"
                                value={printingShop.checkoutFormData.values.addressLine1}
                                onChange={handleOnChange}
                                onBlur={handleOnTouched}
                            />
                            <Form.Control.Feedback type="invalid">Please complete Address Line 1</Form.Control.Feedback>
                        </Form.Group>
                        <br />
                        Address Line 2:
                        <br />
                        <Form.Group>
                            <Form.Control
                                isInvalid={
                                    printingShop.checkoutFormData.touched.addressLine2 && !printingShop.checkoutFormData.valids.addressLine2
                                        ? true
                                        : false
                                }
                                type="text"
                                name="addressLine2"
                                value={printingShop.checkoutFormData.values.addressLine2}
                                onChange={handleOnChange}
                                onBlur={handleOnTouched}
                            />
                            <Form.Control.Feedback type="invalid">Please complete Address Line 2</Form.Control.Feedback>
                        </Form.Group>
                        <br />
                        Town:
                        <br />
                        <Form.Group>
                            <Form.Control
                                isInvalid={printingShop.checkoutFormData.touched.town && !printingShop.checkoutFormData.valids.town ? true : false}
                                type="text"
                                name="town"
                                value={printingShop.checkoutFormData.values.town}
                                onChange={handleOnChange}
                                onBlur={handleOnTouched}
                            />
                            <Form.Control.Feedback type="invalid">Please enter a town</Form.Control.Feedback>
                        </Form.Group>
                        <br />
                        Postcode:
                        <br />
                        <Form.Group>
                            <Form.Control
                                isInvalid={
                                    printingShop.checkoutFormData.touched.postcode && !printingShop.checkoutFormData.valids.postcode ? true : false
                                }
                                type="text"
                                name="postcode"
                                value={printingShop.checkoutFormData.values.postcode}
                                onChange={handleOnChange}
                                onBlur={handleOnTouched}
                            />
                            <Form.Control.Feedback type="invalid">Please enter a post code</Form.Control.Feedback>
                        </Form.Group>
                        <br />
                        Telephone Number:
                        <br />
                        <Form.Group>
                            <Form.Control
                                isInvalid={printingShop.checkoutFormData.touched.tel && !printingShop.checkoutFormData.valids.tel ? true : false}
                                type="text"
                                name="tel"
                                value={printingShop.checkoutFormData.values.tel}
                                onKeyPress={numbersDecKeyPress}
                                onChange={handleOnChange}
                                onBlur={handleOnTouched}
                            />
                            <Form.Control.Feedback type="invalid">Please enter a telephone number</Form.Control.Feedback>
                        </Form.Group>
                        <br />
                    </div>
                )}
            <div style={CheckoutStyles.columnRight}>
                {printingShop.postageOptions.length > 0 && (
                    <div>
                        <strong>Postage Total:</strong> £
                        {(printingShop.postageOptions.find((post) => post.uuid == printingShop.selectedPostage).price / 100).toFixed(2)}
                    </div>
                )}
                <strong> Total:</strong> £{(printingShop.checkoutTotal / 100).toFixed(2)}
            </div>
            <br />
            {stripePromise && clientSecret && (
                <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <PaymentIntent couponDetails={coupon} paymentIntentID={paymentIntentID} />
                </Elements>
            )}
            <Modal show={couponModal.open} onHide={handleCloseCouponModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Coupon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {couponModal.errorType == "normal" && <div>{couponModal.message}</div>}
                    {couponModal.errorType == "date" && (
                        <div>
                            This coupon is only valid between: <br />
                            <br />
                            {console.log(couponModal.dates)}
                            <strong>{couponModal.dates.startDate} 00:00</strong> - <strong>{couponModal.dates.endDate} 23:59</strong>
                        </div>
                    )}
                    {couponModal.errorType == "overAmount" && (
                        <div>
                            This coupon is only valid on orders over <strong>£{couponModal.amount.toFixed(2)}</strong>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseCouponModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );

    return <div>{isBrowser ? browserDisplay : mobileDisplay}</div>;
}

export default Checkout;
